module.exports = __webpack_public_path__ + "static/media/home_banner.a058bdd0.jpg";